// extracted by mini-css-extract-plugin
module.exports = {"container":"credits_container__2-JBK","name":"credits_name__2wwdr"};